<template>
  <div></div>
</template>
<script>
import { urlScheme } from "../api/api";
export default {
  data() {
    return {};
  },
  created() {
      var data = {
          path:"/pages/funPoint/linkGZH/throughApp"
      }
    urlScheme(data).then((res) => {
    location.href = res.data.data.openlink;
    });
  },
};
</script>